import { CLIENT_ID } from "../BaseUrl";

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
  prompt: "select_account",
};

export const apiRequest = {
  scopes: [`api://${CLIENT_ID}/users`],
};
